define(['utils/webpack/mindbreeze_module_map_common'], function(commonModuleMap) {
  // if this code is loaded (by the definition of the bundling)
  return function getModuleMap() {
    var moduleMap = commonModuleMap();
    moduleMap["component!facet"] = require("component!facet");

    return moduleMap;
  }
});
